import { render, staticRenderFns } from "./commonFeedback.vue?vue&type=template&id=573868a0&scoped=true"
import script from "./commonFeedback.vue?vue&type=script&lang=js"
export * from "./commonFeedback.vue?vue&type=script&lang=js"
import style0 from "./commonFeedback.vue?vue&type=style&index=0&id=573868a0&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "573868a0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/hybrid-app/ph-refusaldrainage-h5/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('573868a0')) {
      api.createRecord('573868a0', component.options)
    } else {
      api.reload('573868a0', component.options)
    }
    module.hot.accept("./commonFeedback.vue?vue&type=template&id=573868a0&scoped=true", function () {
      api.rerender('573868a0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/commonFeedback.vue"
export default component.exports